import { createTheme } from "@mui/material";

import athleticCard from 'assets/icons/card-athletic.svg'

const atheticTheme = createTheme({
  overrides: {
    MuiPaper: {
      rounded: {
        border: "none",
        boxShadow: "0px 0px 1px rgba(52,58,67,0.75)",
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 13,
      },
    },
    MuiButton: {
      label: {
        fontFamily: "Lexend Medium",
        textTransform: "uppercase",
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: "8px",
      },
      root: {
        width: "100%",
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        padding: "9px 0 0 0 !important",
      },
      endAdornment: {
        top: "calc(50% - 9px)",
      },
    },
    MuiOutlinedInput: {
      root: {
        // boxShadow: '0px 0px 2px rgba(52,58,67,0.10),0px 1px 2px rgba(52,58,67,0.08),0px 1px 4px rgba(52,58,67,0.08)',
        "label + &": {
          marginTop: "0.5rem",
        },
      },
      adornedStart: {
        paddingLeft: "0px !important",
      },
      input: {
        padding: "14.5px 14px !important",
        borderRadius: 8,
        border: "1px solid #ced4da",
      },
      notchedOutline: {
        display: "none",
      },
      multiline: {
        padding: "0",
        textarea: {
          padding: "11.5px 14px",
        },
      },
    },
    MuiLink: {
      root: {
        fontWeight: "700",
        "&:focus": {
          outlineColor: "#266678",
        },
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '.rccs__card > div, .rccs__card__background': {
          background: `url(${athleticCard})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          color: '#FFF'
        },
        '.rccs__card:not(.rccs__card--unknown) .rccs__card__background': {
          left: '-1000%',
          transition: 'none'
        },
        '.rccs__chip': {
          top: '25%',
        }
      }
    }
  },
  palette: {
    type: "light",
    action: {
      background: "#E3E3E3",
      disabled: "white",
    },
    primary: {
      light: "#E50051",
      main: "#E50051",
      dark: "#E50051",
      contrastText: "#fff",
    },
    secondary: {
      light: "#282828",
      main: "#282828",
      dark: "#282828",
    },
    error: {
      light: "#d49494",
      main: "#cb7c7a",
      dark: "#a26362",
    },
    warning: {
      light: "#dab47d",
      main: "#cda35f",
      dark: "#b99356",
    },
    success: {
      light: "#73baa9",
      main: "#48ac98",
      dark: "#3a8a7a",
    },
    text: {
      primary: "#0f2930",
      secondary: "#53627c",
      disabled: "#a6aebc",
      hint: "#a6aebc",
    },
    background: {
      paper: "#ffffff",
      default: "#ffffff",
    },
  },
  shadows: [
    "none",
    "0px 0px 12px rgba(52,58,67,0.10),0px 1px 2px rgba(52,58,67,0.08),0px 1px 4px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 2px 5px rgba(52,58,67,0.08),0px 5px 15px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 5px 10px rgba(52,58,67,0.08),0px 15px 35px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 10px 20px rgba(52,58,67,0.08),0px 20px 40px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
  ],
  typography: {
    fontFamily: [
      '"Lexend"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h1: {
      fontWeight: "700",
    },
    h2: {
      fontWeight: "700",
    },
    h3: {
      fontWeight: "700",
    },
    h4: {
      fontWeight: "700",
    },
    h5: {
      fontWeight: "700",
      fontFamily: "Lexend Medium",
      textTransform: "uppercase",
      fontSize: 15,
    },
    h6: {
      fontWeight: "700",
    },
    body1: {
      fontFamily: "Lexend Medium",
      color: "#282828",
      fontWeight: 100,
      fontSize: 16,
      wordBreak: "break-word",
    },
    body2: {
      fontFamily: "Lexend",
      color: "#282828",
      fontWeight: 100,
      fontSize: 16,
      wordBreak: "break-word",
    },
    title: {
      fontFamily: "EDO",
      color: "#282828",
      fontWeight: 100,
      fontSize: 35,
    },
    button: {
      textTransform: "none",
      fontSize: "15px",
      fontWeight: "bold",
      color: "black",
      height: 45,
      width: 224,
    },
  },
  shape: {
    borderRadius: 0,
  },
});

export default atheticTheme;
